import Icon from 'veui/components/Icon'

Icon.register({
  'user-circle': {
    raw: '<g stroke="currentColor" stroke-width="4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><circle cx="24" cy="24" r="22"/><circle cx="24" cy="16" r="6"/><path d="M7 38c3-5 9-10 17-10s14 5 17 10"/></g>',
    width: '48',
    height: '48'
  }
})
